import React from 'react';
import { useTranslation } from 'react-i18next';

import { FeatureFlagsDrawerContent } from '@/backoffice/features/tenants/components/feature-flags/feature-flags-drawer-content';
import { TManageFeatureFlagsProps } from '@/backoffice/features/tenants/components/feature-flags/feature-flags.types';
import { useReadSuperTenantQuery } from '@/backoffice/redux/api/backoffice/backoffice-api';
import { ManageIcon } from '@/shared/assets/icons/manage-icon';
import { DrawerController } from '@/shared/components/ui/drawer-controller/drawer-controller';
import { MenuItem } from '@/shared/components/ui/menu-item/menu-item';
import { Can } from '@/shared/features/permissions/components/can/can';

export const ManageFeatureFlags: React.FC<TManageFeatureFlagsProps> = ({
  tenantId,
  onClose,
}) => {
  const { t } = useTranslation();
  const { data } = useReadSuperTenantQuery();

  const hasEnabledFeatureFlags =
    data?.readSuperTenant.featureFlags?.some((flag) => flag.isEnabled) ?? false;

  if (!hasEnabledFeatureFlags) {
    return null;
  }

  return (
    <Can action="backofficeTenant:updateTenant" ids={tenantId}>
      <DrawerController
        trigger={
          <MenuItem icon={<ManageIcon />}>
            {t('backoffice:feature_flags.manage')}
          </MenuItem>
        }
        title={t('backoffice:feature_flags.manage')}
        width="500px"
      >
        {(handleClose, isOpen) =>
          isOpen ? (
            <FeatureFlagsDrawerContent
              tenantId={tenantId}
              handleClose={() => {
                onClose?.();
                handleClose();
              }}
            />
          ) : null
        }
      </DrawerController>
    </Can>
  );
};
